import { Flex, FlexProps, Text } from '@chakra-ui/react'
import React from 'react'
import {
  NotificationBadgeSize,
  NotificationBadgeVariant,
  useNotificationBadgeStyle,
} from '~/components/shared/componentStyles/NotificationBadge.style'
import { Size } from '~/types/ThemeTypes'

interface NotificationBadgeProps extends FlexProps {
  count: string | number | undefined
  variant?: NotificationBadgeVariant
  size?: NotificationBadgeSize
}

export const NotificationBadge = ({
  count,
  variant = NotificationBadgeVariant.Notification,
  size = Size.md,
  ...rest
}: NotificationBadgeProps) => {
  const styles = useNotificationBadgeStyle({
    variant,
    size,
  })

  return (
    <Flex sx={styles.container} {...rest}>
      <Flex sx={styles.contentContainer}>
        <Text sx={styles.text}>{count}</Text>
      </Flex>
    </Flex>
  )
}
